export default __webpack_public_path__ + "static/media/lieferheld_xl2.b0a4bb0a.png";